import CustomerScreenShell from "@/components/customer-screen-shell";
import Notice from "@buildpy/ui/notice";

/** 없는 토큰. 고객이 보는 화면이라 「404」 대신 무엇을 하면 되는지 적는다. */
const NotFound = () => {
  return (
    <CustomerScreenShell centered>
      <Notice
        body="링크가 잘못되었거나 이미 삭제된 견적서입니다. 받으신 문자의 링크를 다시 확인하시거나 담당자에게 문의해 주세요."
        title="견적서를 찾을 수 없습니다"
      />
    </CustomerScreenShell>
  );
};

export default NotFound;
